  import React, { useState, useEffect, useRef, useMemo, useLayoutEffect, useCallback } from 'react';
  import { MentionsInput, Mention } from 'react-mentions';
  import { toast } from "react-toastify";
  import "./TaskDetailsPopup.css";
  import { Pencil } from "lucide-react";
  import DatePicker from 'react-datepicker'
  import "react-datepicker/dist/react-datepicker.css";
  import Swal from 'sweetalert2';
  import axios from "axios";
  import save_icon from '../../icons/save-icon.svg'
  import delete_icon from '../../icons/delete-icon.svg'
  import edit_icon from '../../icons/edit-icon.svg'


  const TaskDetailsModal = ({ task,setTasks,setLogs, buckets, onClose,allUsers, showAssigneeInput,setShowAssigneeInput, currentUser, onTaskUpdate, shownImages,userSuggestion, setShownImages,selectedTask,saveLog,logs,users,taskEdits,setTaskEdits, removedAssignee,removedAssignees,setRemovedAssignees,setAssigningUser }) => {
    const draftKey = `taskDraft:${task.id}`;
    const storedDraft = localStorage.getItem(draftKey);
    const initialState = storedDraft ? JSON.parse(storedDraft) : {};
 
    const [selectedBucket, setSelectedBucket] = useState(initialState.selectedBucket || task.bucket_id);
    const [status, setStatus] = useState(initialState.status || task.status);
    const [priority, setPriority] = useState( initialState.priority || task.priority);
    const [startDate, setStartDate] = useState((initialState.startDate) ||
        (task.start_date ? String(task.start_date).slice(0, 10) : "")
    );
    const [dueDate, setDueDate] = useState((initialState.dueDate) ||
        (task.due_date ? String(task.due_date).slice(0, 10) : "")
    );
    const [notes, setNotes] = useState(initialState.notes || task.description || "");
    const [assigneeInput,setAssigneeInput] = useState("")
    const [bucketName,setBucketName] = useState(()=>{
        const bucketMap = new Map(buckets.map(b => [b.id, b]));
        console.log(`BucketID:${task.bucket_id}`)
        const bucketFound = bucketMap.get(task.bucket_id);
        const bucketFoundedName = bucketFound ? bucketFound.name : "";
        return bucketFoundedName
    })
    const [checklist, setChecklist] = useState(initialState.checklist || task.checklist || []);
    const [newItemVisible, setNewItemVisible] = useState(initialState.newItemVisible || false);
    const [newItem, setNewItem] = useState(initialState.newItem || '');
    const [attachments, setAttachments] = useState(initialState.attachments || task.attachments || []);
    const [showOnCard,setShowOnCard] = useState(()=>{
        const stored = localStorage.getItem(task.id)
        if (stored){
            return true
        }
        else {
            return false
        }
    })
    const [showCard,setShowCard] = useState(showOnCard)
    const [comments, setComments] = useState(initialState.comments || task.comments || []);
    const [commentInput, setCommentInput] = useState(initialState .commentInput || '');
    const [showDropdown,setShowDropdown] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [isEditingName, setIsEditingName] = useState(false);
    const [editedName, setEditedName] = useState(initialState.editedName || task.name);
    const nameInputRef = useRef(null);
    const [userSuggestions,setUserSuggestions] = useState(userSuggestion)
    const [editIndex, setEditIndex] = useState(initialState.editIndex ?? null);
    const [lastEditIndex,setLastEditindex] = useState(initialState.lastEditIndex ?? null)
    const [editedText, setEditedText] = useState(initialState.editedText || "");
    const [commentEditIndex, setCommentEditIndex] = useState(initialState.commentEditIndex ?? null);
    const [lastCommentEditIndex,setLastCommentEditindex] = useState(initialState.lastCommentEditIndex ?? null)
    const [commentEditedText, setCommentEditedText] = useState(initialState.commentEditedText || "");
    const inputRef = useRef(null);
    const [assignedTo,setAssignedTo] = useState(taskEdits.assignedTo);
    const [showNotes,setShowNotes] = useState(initialState.showNotes ?? task.show_notes)
    const [showChecklist,setShowChecklist] = useState(initialState.showChecklist ?? task.show_checklist)
    const [showImage,setShowImage] = useState(initialState.showImage ?? task.show_image)
    const normalizeArray = (arr) => (arr ? [...arr].sort() : []);
    const wrapperRef = useRef(null);
    const scrollRef = useRef(null);
    const scrollKey = `task_scroll_${task.id}`; // unique key per task
    const notesRef = useRef(null);
    const checklistRef = useRef(null);
    const oldChecklistRef = useRef(null);
    const commentsRef = useRef(null);
    const editCommentRef = useRef(null);

    {console.log("Last edit index:",initialState.editIndex)}
    {console.log("Last edited save index:",initialState.lastEditIndex)}
    {console.log("Last comment edited save index:",initialState.lastCommentEditIndex)}

  // ✅ Restore scroll when popup opens or updates
  useEffect(() => {
    const savedScroll = localStorage.getItem(scrollKey);
    if (scrollRef.current && savedScroll) {
      scrollRef.current.scrollTop = parseInt(savedScroll, 10);
    }
  }, [task.id]);

  // ✅ Listen for user scroll & store position
  const handleScroll = () => {
    if (scrollRef.current) {
      localStorage.setItem(scrollKey, scrollRef.current.scrollTop);
    }
  };

  // ✅ When task updates (after pusher update), reapply last saved scroll
  useEffect(() => {
    const savedScroll = localStorage.getItem(scrollKey);
    if (scrollRef.current && savedScroll) {
      scrollRef.current.scrollTop = parseInt(savedScroll, 10);
    }
  });


    function formatDate(dateInput) {
        if (!dateInput) return "";

        let dateObj;
        if (dateInput instanceof Date) {
            dateObj = new Date(dateInput.getTime() - dateInput.getTimezoneOffset() * 60000); // adjust for local timezone
        } else {
            // Try parsing strings like "dd/MM/yyyy"
            const dateString = String(dateInput);
            if (dateString.includes("/")) {
                const [day, month, year] = dateString.split("/");
                dateObj = new Date(`${year}-${month}-${day}`);
            } else {
                dateObj = new Date(dateInput);
            }
        }

        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, "0");
        const day = String(dateObj.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    }

    useEffect(() => {
        if (!task) return;
 
        const draftKey = `taskDraft:${task.id}`;
        const draft = {
            editedName: editedName,
            selectedBucket: task.bucket_id,
            status: task.status,
            priority: task.priority,
            startDate: task.start_date || "",
            dueDate: task.due_date || "",
            notes: notes || task.description || "",
            checklist: task.checklist || [],
            attachments: task.attachments || [],
            comments: task.comments || [],
            showNotes: task.show_notes,
            showChecklist: task.show_checklist,
            showImage: task.show_image,
            showCard: true,
            commentInput,
            newItem,
            editedText,
            newItemVisible,
            editIndex:lastEditIndex,
            lastEditIndex,
            commentEditIndex:lastCommentEditIndex,
            lastCommentEditIndex,
            commentEditedText
        };
 
        // Store in localStorage if not already stored
        if (!localStorage.getItem(draftKey)) {
            localStorage.setItem(draftKey, JSON.stringify(draft));
        }
    }, [task?.id]); // only runs when popup opens for a new task
 
    useEffect(() => {
    saveDraft();
        }, [
            editedName, selectedBucket, status, priority,
            startDate, dueDate, notes, checklist,
            attachments, comments, showNotes, showChecklist, 
            showImage, showCard, commentInput, newItem, editedText,
            newItemVisible,editIndex,lastEditIndex,commentEditIndex,
            lastCommentEditIndex,commentEditedText
        ]);
 
        useEffect(() => {
            const draft = loadDraft();
            if (draft) {
                setEditedName(draft.editedName);
                setSelectedBucket(draft.selectedBucket);
                setStatus(draft.status);
                setPriority(draft.priority);
                setStartDate(draft.startDate);
                setDueDate(draft.dueDate);
                setNotes(draft.notes);
                setChecklist(draft.checklist);
                setAttachments(draft.attachments);
                setComments(draft.comments);
                setShowNotes(draft.showNotes);
                setShowChecklist(draft.showChecklist);
                setShowImage(draft.showImage);
                setShowCard(draft.showCard);
                setCommentInput(draft.commentInput);
                setNewItem(draft.newItem)
                setEditedText(draft.editedText)
                setNewItemVisible(draft.newItemVisible)
                setEditIndex(draft.editIndex)
                setLastEditindex(draft.lastEditIndex)
                setCommentEditIndex(draft.commentEditIndex)
                setLastCommentEditindex(draft.lastCommentEditIndex)
                setCommentEditedText(draft.commentEditedText)
            }
        }, []);
 
 
 
     useEffect(() => {
        const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setShowDropdown(false);
        }
        };
 
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    function setRefs(...refs) {
        return (el) => {
            refs.forEach((ref) => {
            if (!ref) return;
            if (typeof ref === "function") ref(el);
            else ref.current = el;
            });
        };
    }

      

    const handleFocusField = (fieldName, ref) => {
        if (!ref?.current) return;

        const el = ref.current;

        // save the field name
        localStorage.setItem("lastFocusedField", fieldName);

        // get current cursor position
        const pos = el.selectionStart ?? 0;

        // ✅ store exact position (no manual +1 or +2 here)
        localStorage.setItem("cursorPosition", pos);
    };

    const handleBlur = () => {
        localStorage.removeItem("lastFocusedField");
        localStorage.removeItem("cursorPosition");
    };

    const handleBlurField = (fieldKey) => {
        if (fieldKey === "checklist") {
            setLastEditindex(null);
            localStorage.removeItem("lastEditIndex");
        } else if (fieldKey === "comment") {
            setLastCommentEditindex(null);
            localStorage.removeItem("lastCommentEditIndex");
        }
    };

    const handleSelect = (ref) => {
    const el = ref?.current?.inputElement || ref?.current; // handle MentionsInput or textarea
    if (!el) return;

    const pos = el.selectionStart ?? 0;
    localStorage.setItem("cursorPosition", pos);
    console.log("Saved cursor position:", pos);
    };

    useEffect(() => {
    const lastFocused = localStorage.getItem("lastFocusedField");
    const pos = parseInt(localStorage.getItem("cursorPosition"), 10);

    // Dynamically choose the right ref
    let elRef = null;
    if (lastFocused === "notes") elRef = notesRef;
    else if (lastFocused === "checklist") elRef = checklistRef;
    else if (lastFocused === "oldChecklist") elRef = oldChecklistRef;
    else if (lastFocused === "editComment") elRef = editCommentRef;
    else if (lastFocused === "comments") elRef = commentsRef;

    if (!elRef?.current) return;

    // Restore focus + cursor safely
    requestAnimationFrame(() => {
        const el = elRef.current.inputElement || elRef.current; // handle both types
        if (!el) return;

        el.focus();

        requestAnimationFrame(() => {
        const length = el.value?.length ?? 0;
        const safePos = Math.min(isNaN(pos) ? length : pos, length);
        const finalPos = Math.min(safePos + 1, length); // ✅ +1 to prevent off-by-one

        el.setSelectionRange?.(finalPos, finalPos);
        console.log("Restored cursor position:", finalPos);
        });
    });
    }, []);


       
    const handleFocus = () => {
        setShowDropdown(true);
    };
    const saveDraft = () => {
        const draft = {
            editedName,
            selectedBucket,
            status,
            priority,
            startDate,
            dueDate,
            notes,
            checklist,
            attachments,
            comments,
            showNotes,
            showChecklist,
            showImage,
            showCard,
            commentInput,
            newItem,
            editedText,
            newItemVisible,
            editIndex:lastEditIndex,
            lastEditIndex,
            commentEditIndex:lastCommentEditIndex,
            lastCommentEditIndex,
            commentEditedText
        };
        localStorage.setItem(draftKey, JSON.stringify(draft));
    };
 
    const loadDraft = () => {
        const raw = localStorage.getItem(draftKey);
        return raw ? JSON.parse(raw) : null;
    };
 
    const removeDraft = () => {
        localStorage.removeItem(draftKey);
    };

    useEffect(() => {
        if (inputRef.current) inputRef.current.focus();
    }, [editIndex]);

     useEffect(() => {
        if (inputRef.current) inputRef.current.focus();
    }, [commentEditIndex]);

    const fetchUserSuggestions = async (query) => {
        try {
            const res = await axios.get('https://teams.tidyds.com/api/users/search?q=' + query);
            const usersWithFullPic = res.data.map(user => ({
                ...user,
                profile_pic: `https://teams.tidyds.com${user.profile_pic}` // Always prepending because profile_pic is like "uploads/..."
            }));
            setUserSuggestions(usersWithFullPic);
            
            console.log(res.data);
            console.log(usersWithFullPic);   
        } catch (error) {
            console.error(error);
        }
    };
    
    const handleFile = async (e) => {
        const files = Array.from(e.target.files);
        const MAX_SIZE = 2 * 1024 * 1024;
        
        // Check file sizes
        for (let file of files) {
            if (file.size > MAX_SIZE) {
                toast.error(`${file.name} exceeds 2MB. Please select a smaller file.`);
                e.target.value = ''; 
                return;
            }
        }

        e.target.value = '';
        for (let file of files) {
            const formData = new FormData();
            formData.append('file', file);
        
            try {
            const res = await fetch('https://teams.tidyds.com/api/upload', {
                method: 'POST',
                body: formData,
            });
        
            const data = await res.json();
        
            if (data.url) {
                setAttachments((prev) => [...prev, { url: data.url, name: file.name }]);
            } else {
                console.error('Upload failed:', data);
            }
            } catch (error) {
            console.error('Upload error:', error);
            }
        }
    };   

    const handleAddChecklistItem = () => {
        setNewItemVisible(false);
        if (!newItem || newItem.trim() === '') return;
        if (newItem.trim() !== '') {
            setChecklist(prev => [...prev, { text: newItem, done: false }]);
            setNewItem('');
        }
    };

    const toggleChecklistItem = (index) => {
        const updated = checklist.map((item, i) =>
            i === index ? { ...item, done: !item.done } : item
        );

        setChecklist(updated);
        console.log("Toggle Check:", JSON.stringify(updated));
    };

    const removeChecklistItem = (index) => {
        setChecklist(prev => prev.filter((_, i) => i !== index));
        
    };

    const removeComment = (index) => {
        setComments(prev => prev.filter((_, i) => i !== index));
        
    };


    const removeAttachment = (index) => {
        const removed = attachments[index];
            const imageUrl = `https://teams.tidyds.com${removed.url}`;

            setAttachments(prev => prev.filter((_, i) => i !== index));

            // Update shownImages if the removed image was being shown
            if (shownImages[task.id] === imageUrl) {
                setShownImages(prev => {
                const updated = { ...prev };
                delete updated[task.id];
                return updated;
                });
            }
        
    };
    const getMentions = (text = "", userSuggestions = []) => {
        const mentions = [];
        const mentionRegex = /@\[([^\]]+)\]\((\d+)\)/g; 
        // Pattern for markup like @[Name](id) if you store it that way

        let match;
        while ((match = mentionRegex.exec(text)) !== null) {
            const display = match[1];
            const id = match[2];
            mentions.push({ id, display });
        }

        // ✅ If you are using custom plain "@Name" without markup:
        if (mentions.length === 0 && userSuggestions.length > 0) {
            userSuggestions.forEach(user => {
            const pattern = new RegExp(`@${user.name}`, "gi");
            if (pattern.test(text)) {
                mentions.push({ id: user.id.toString(), display: user.name });
            }
            });
        }

        return mentions;
    };

    const commentAddAssignee = (user) => {
        const userId = user.id.toString();

        setAssignedTo((prev) => {
            if (prev.includes(userId)) return prev; // already assigned
            return [...prev, userId]; // add new
        });
    };
    
    const handleAddComment = () => {
        if (commentInput.trim() !== '') {
            const mentions = getMentions(commentInput, userSuggestions);

            const newComment = {
            user: currentUser?.name || "Unknown User",
            text: commentInput,
            mentions: mentions.map(m => m.id), 
            time: new Date().toLocaleString(),
            };

            setComments(prev => [newComment, ...prev]);
            setCommentInput('');

            mentions.forEach(user => {
            commentAddAssignee(user);
            });
        }
    };


    // const getBucketName = (bucket_id) => {
    //   const bucket = buckets?.find((b) => b.id === bucket_id);
    //   return bucket ? bucket.name : 'No Bucket';
    // };

    const formatForLog = (date) => {
        if (!date) return "";
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0"); // months are 0-based
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

   const generateLogDescription = (oldTask, updatedTask, userName, bucketsMap) => {
        const logs = [];
        const oldNotes = oldTask.description ?? '';
        const newNotes = updatedTask.notes ?? '';

        const oldChecklist = task.checklist || [];
        const newChecklist = updatedTask.checklist || [];
        const oldItems = oldChecklist || [];
        const newItems = newChecklist || [];
        const oldTexts = oldChecklist.map(item => item.text);
        const newTexts = newChecklist.map(item => item.text);
        const addedTexts = newTexts.filter(text => !oldTexts.includes(text)).map(text => text.replace(/[\r\n\u2028\u2029]+/g, " ").trim());

        const oldUrls = oldTask.attachments.map(att => att.url);
        const newUrls = updatedTask.attachments.map(att => att.url);

        const added = updatedTask.attachments.filter(att => !oldUrls.includes(att.url));
        const removed = oldTask.attachments.filter(att => !newUrls.includes(att.url));

        // 🔹 Assigned Users logging (safe)
        const oldAssigned = oldTask.assignedTo || [];
        const newAssigned = updatedTask.assignedTo || [];
 
        // Newly assigned users
        const addedUsers = newAssigned.filter(uNew =>
            !oldAssigned.some(uOld => (typeof uOld === 'object' ? uOld.id : parseInt(uOld)) === (typeof uNew === 'object' ? uNew.id : parseInt(uNew)))
        );
 
        addedUsers.forEach(user => {
            let userName;
            if (typeof user === "object") {
                userName = user.name;
            } else {
                const foundUser = allUsers.find(u => u.id === parseInt(user));
                userName = foundUser ? foundUser.name : `User(${user})`;
            }
            logs.push(`Assigned this task to ${userName}`);
        });
 
        // Removed users
        const removedUsers = oldAssigned.filter(uOld =>
            !newAssigned.some(uNew => (typeof uNew === 'object' ? uNew.id : parseInt(uNew)) === (typeof uOld === 'object' ? uOld.id : parseInt(uOld)))
        );
 
        removedUsers.forEach(user => {
            let userName;
            if (typeof user === "object") {
                userName = user.name;
            } else {
                const foundUser = allUsers.find(u => u.id === parseInt(user));
                userName = foundUser ? foundUser.name : `User(${user})`;
            }
            logs.push(`Unassigned user ${userName} from this task`);
        });

        if (oldTask.name !== updatedTask.name) {
            logs.push(`Changed the name "${oldTask.name}" to "${updatedTask.name}" of this task`);
        }

        if (formatForLog(oldTask.due_date)){ 
            if (formatForLog(oldTask.due_date) !== formatForLog(updatedTask.due_date)){
                logs.push(`Updated the due date "${formatForLog(oldTask.due_date)}" to "${formatForLog(updatedTask.due_date)}" of this task`);
            }
        }else if(updatedTask.due_date){
          logs.push(`Sets due date "${formatForLog(updatedTask.due_date)}" of this task`);
        }

        if (formatForLog(oldTask.start_date)){ 
            if (formatForLog(oldTask.start_date) !== formatForLog(updatedTask.start_date)){
            logs.push(`Updated the start date "${formatForLog(oldTask.start_date)}" to "${formatForLog(updatedTask.start_date)}" of this task`);
            }
        }else if(updatedTask.start_date){
          logs.push(`Sets start date "${formatForLog(updatedTask.start_date)}" of this task`);
        }

        if (oldTask.position !== updatedTask.position) {
            logs.push(`Changed the position "${oldTask.position}" to "${updatedTask.position}" of this task`);
        }

        if (oldTask.bucket_id !== updatedTask.bucket_id) {
            const oldBucketName = bucketsMap[oldTask.bucket_id] || 'Unknown';
            const newBucketName = bucketsMap[updatedTask.bucket_id] || 'Unknown';
            logs.push(`Moved this task from "${oldBucketName}" to "${newBucketName}"`);
        }

        if (oldTask.priority !== updatedTask.priority) {
            logs.push(`Changed the priority "${oldTask.priority}" to "${updatedTask.priority}" of this task`);
        }

        if (oldTask.status !== updatedTask.status) {
            logs.push(`Changed the status "${oldTask.status}" to "${updatedTask.status}" of this task`);
        }

        if (oldNotes!== newNotes) {
            logs.push(`Changed the notes "${oldNotes}" to "${newNotes}" of this task`);
        }

        newItems.forEach((newItem, index) => {
            const oldItem = oldItems[index];
 
            // Skip if newItem is missing
            if (!newItem) return;
 
            // Case 1: Newly marked as done
            if (oldItem && !oldItem.done && newItem.done) {
                logs.push(`Checklist "${newItem.text}" is completed`);
            }
 
            // Case 2: Unchecked
            if (oldItem && oldItem.done && !newItem.done) {
                logs.push(`Checklist "${newItem.text}" is unchecked`);
            }
 
            // Case 3: Newly added & already done
            if (!oldItem && newItem.done) {
                logs.push(`Checklist "${newItem.text}" is completed`);
            }
 
            // Case 4: Newly added but not done
            if (!oldItem && !newItem.done) {
                logs.push(`Checklist "${newItem.text}" is added`);
            }
        });
 
         const deletedChecklist = oldItems.filter(oldItem =>
            !newItems.some(newItem => newItem.text === oldItem.text)
        );
        deletedChecklist.forEach(item => {
            logs.push(`Deleted checklist "${item.text}"`);
        });
 
        if (added.length > 0) {
            added.forEach( att =>{
                logs.push(`Added attachment: ${att.name}`);
            }
            )
        }
 
        if (removed.length > 0) {
            removed.forEach(att =>{
                logs.push(`Deleted attachment: ${att.name}`);
            }
            )
        }
 
        if (JSON.stringify(oldTask.comments) !== JSON.stringify(updatedTask.comments)) {
            const oldComments = oldTask.comments?.map(c => c.text) || [];
            const newComments = updatedTask.comments?.map(c => c.text) || [];
 
            const addedComments = newComments.filter(c => !oldComments.includes(c));
 
            if (addedComments.length > 0) {
                addedComments.forEach(c => logs.push(`Added new comment: "${c}" on this task`))
            }
 
            const removedComments = oldComments.filter(c => !newComments.includes(c));
 
            if (removedComments.length > 0) {
                removedComments.forEach(c => logs.push(`Deleted comment: "${c}" from this task`));
            }
        }

        return logs.length ? logs.join(',') : null;
    };

    const taskLogs = logs?.filter(log => log.task_id === task.id) || [];

    const bucketsMap = {};
    buckets.forEach(bucket => {
    bucketsMap[bucket.id] = bucket.name;
    });

    {console.log("Task Logs",taskLogs)}

    
    const handleSave = () => {
        // Normalization helpers
        const normalizeDate = (val) => {
            if (!val) return null;
            if (typeof val === "string") return val.split("T")[0];
            if (val instanceof Date) return val.toISOString().split("T")[0];
            return val;
        }; 
        const normalizeArray = (arr) => (arr ? [...arr].sort() : []); 
        const normalizeAssigned = (arr) =>
            (arr || []).map((u) => (typeof u === "object" ? u.id : parseInt(u))).sort();
        const normalizeValue = (val) => {
            if (val === undefined || val === null) return ""; 
            return val;
        };

        // Changes detection
        const changes = {};

        if (task.name !== editedName) changes.name = { old: task.name, new: editedName };
        if (task.bucket_id !== selectedBucket) changes.bucket_id = { old: task.bucket_id, new: selectedBucket };
        if (task.status !== status) changes.status = { old: task.status, new: status };
        if (task.priority !== priority) changes.priority = { old: task.priority, new: priority };

        const oldDescription = normalizeValue(task.description);
        const newDescription = normalizeValue(notes);
        if (oldDescription !== newDescription) {
            changes.description = { old: oldDescription, new: newDescription };
        }

        // Normalize dates
        const oldStart = normalizeDate(task.start_date);
        const newStart = normalizeDate(startDate);
        if (oldStart !== newStart) changes.start_date = { old: oldStart, new: newStart };

        const oldDue = normalizeDate(task.due_date);
        const newDue = normalizeDate(dueDate);
        if (oldDue !== newDue) changes.due_date = { old: oldDue, new: newDue };

        // Deep compare arrays
        if (JSON.stringify(normalizeArray(task.checklist)) !== JSON.stringify(normalizeArray(checklist)))
            changes.checklist = { old: task.checklist, new: checklist };

        if (JSON.stringify(normalizeArray(task.attachments)) !== JSON.stringify(normalizeArray(attachments)))
            changes.attachments = { old: task.attachments, new: attachments };

        if (JSON.stringify(normalizeArray(task.comments)) !== JSON.stringify(normalizeArray(comments)))
            changes.comments = { old: task.comments, new: comments };

        //Show on card
        if (task.show_notes !== showNotes){
            changes.show_notes = {old:task.show_notes, new:showNotes}
        }

        if (task.show_checklist !== showChecklist){
            changes.show_checklist = {old:task.show_checklist, new:showChecklist}
        }

        if (task.show_image !== showImage){
            changes.show_image = {old:task.show_image, new:showImage}
        }

        // Assigned users comparison
        const oldAssigned = normalizeAssigned(task.assignedTo);
        const newAssigned = normalizeAssigned(taskEdits.assignedTo);
        if (JSON.stringify(oldAssigned) !== JSON.stringify(newAssigned))
            changes.assigned_users = { old: oldAssigned, new: newAssigned };

        if (Object.keys(changes).length === 0) {
            console.log("No changes detected");
            return;
        }

        const updatedTask = {
            ...task,
            name: editedName,
            bucket_id: selectedBucket,
            status, 
            priority,
            start_date: formatDate(startDate),
            due_date: formatDate(dueDate),
            notes,
            description:notes,
            checklist,
            attachments,
            comments,
            assignedTo: assignedTo.map(id => parseInt(id)),
            show_notes:showNotes,
            show_checklist:showChecklist,
            show_image:showImage,
        };
        
        const oldBucketId = task.bucket_id;
        
        // 🔹 Save ALL changed fields to localStorage
        Object.entries(changes).forEach(([field, value]) => {
            let newVal = value.new;
            if (field === "assigned_users") newVal = assignedTo;
            if (field === "description") newVal = notes;
            if (field === "checklist") newVal = checklist;
            if (field === "attachments") newVal = attachments;
            if (field === "comments") newVal = comments;
            if (["show_notes","show_checklist","show_image"].includes(field)) newVal = updatedTask[field];
            if (["start_date","due_date"].includes(field)) newVal = updatedTask[field];
            
            localStorage.setItem(`task_${task.id}_${field}`, JSON.stringify(newVal));
        });
        
        // 🔹 Optimistic update in Kanban board
        setTasks(prev => {
            const updatedBuckets = { ...prev };
            const bucketId = updatedTask.bucket_id;
            
            if (!updatedBuckets[bucketId]) updatedBuckets[bucketId] = [];
            
            // Remove the task if it exists in this bucket
            updatedBuckets[bucketId] = updatedBuckets[bucketId].filter(t => t.id !== updatedTask.id);
            
            // Add the updated task
            updatedBuckets[bucketId].push(updatedTask);
            
            // 🔹 Sort by position in reverse
            updatedBuckets[bucketId].sort((a, b) => b.position - a.position);
            
            // Remove from old bucket if moved
            if (oldBucketId && oldBucketId !== bucketId) {
                updatedBuckets[oldBucketId] = updatedBuckets[oldBucketId].filter(t => t.id !== updatedTask.id);
            }
            
            return updatedBuckets;
        });
        
        // Generate log description
        const description = generateLogDescription(task, updatedTask, currentUser.name,bucketsMap );

        // // Update logs state
        // setLogs(prevLogs => {
        //     // always keep logs as an array
        //     const logsArray = Array.isArray(prevLogs) ? prevLogs : [];

        //     const newLog = {
        //         id: Date.now(),              // temporary ID until backend gives real one
        //         task_id: task.id,            // ✅ backend-style key
        //         user_id: currentUser.id,     // ✅ backend-style key
        //         user_name: currentUser.name, // ✅ backend-style key
        //         description,                 
        //         created_at: new Date().toISOString() // ✅ matches backend timestamp
        //     };

        //     return [newLog, ...logsArray]; // prepend new log
        // });

        // {console.log("Logs in task update:",logs)}

        // Send log to backend
        saveLog({   
            taskId: task.id,
            userId: currentUser.id, 
            description,
        });
        removeDraft();
        // Update task in frontend/backend
        onTaskUpdate(updatedTask, oldBucketId);
        setShowAssigneeInput(false)
        removedAssignee(task.id)
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 3000);
        selectedTask(null);
    };


    const getChecklistProgress = () => {
      if (checklist.length === 0) return 0;
      const completed = checklist.filter(item => item.done).length;
      return Math.round((completed / checklist.length) * 100);
    };   
    
    // Handle assignee input
        const handleAssigneeInput = async (e) => {
        const value = e.target.value;
            setTaskEdits(prev => ({ ...prev, assigneeInput: value }));
            await fetchUserSuggestions(value); // only updates suggestions
        };

        // Add assignee
        const addAssignee = (user) => {
            setAssigningUser(true)
            setTaskEdits((prev) => {
                // check if already assigned
                if (prev.assignedTo?.includes(user.id.toString())) {
                return prev; // no change if already assigned
                }

                return {
                ...prev,
                assignedTo: [...(prev.assignedTo || []), user.id.toString()], // only IDs
                assignees: [...(prev.assignees || []), user], // full objects
                assigneeInput: "", // clear search
                };
            });
            
            setShowAssigneeInput(false);
        };

        // Remove assignee
        const removeAssignee = (userId) => {
            setAssigningUser(true)
            setTaskEdits(prev => ({
                ...prev,
                assignedTo: prev.assignedTo.filter(id => id !== userId.toString()),
                assignees: prev.assignees.filter(u => u.id.toString() !== userId.toString())
            }));
        };

        // Suggestions (exclude already assigned)
        const filteredSuggestions = userSuggestions.filter(u => {
            const query = taskEdits.assigneeInput.toLowerCase().trim();
            const inAssigned = taskEdits.assignedTo.includes(u.id.toString());

            // Match name or email contains the query
            const matches =
                u.name.toLowerCase().includes(query) ||
                u.email.toLowerCase().includes(query);

            return !inAssigned && matches;
        });


        const handleOverlayClick = useCallback(
            (e) => {
            if (e.target.classList.contains('custom-modal-overlay')) {
                // Auto-save before closing
                if (task) {
                handleSave(task);  // call your save function
                }
                onClose();       // then close the popup
            }
            },
            [onClose, handleSave, task] // task must be in deps
        );

        // ✅ Attach click listener to overlay
        useEffect(() => {
            const overlay = document.querySelector('.custom-modal-overlay');
            if (!overlay) return;

            overlay.addEventListener('click', handleOverlayClick);
            return () => overlay.removeEventListener('click', handleOverlayClick);
        }, [handleOverlayClick]);

        if (!task) return null;

        const editChecklist = (index) => {
            setEditIndex(index);
            setEditedText(checklist[index].text);
            {console.log("Edit index :",initialState.editIndex)}
        };

        const saveChecklistItem = (index) => {
            setChecklist((prev) =>
                prev.map((item, i) =>
                    i === index ? { ...item, text: editedText } : item
            )
            );
            setEditIndex(null);
        };

        function formatComment(text) {
            return text.replace(/@(\d+)\|(\w+)/g, '@$2'); 
        }
        const editComment = (index) => {
            setCommentEditIndex(index);
            setCommentEditedText(comments[index].text); 
        };

        const saveComment = (index) => {
            if (!commentEditedText.trim()) return; 
            setComments((prev) =>
            prev.map((c, i) =>
                i === index ? { ...c, text: commentEditedText } : c
            )
            );
            setCommentEditIndex(null);
            setCommentEditedText("");
        };

        const CommentDisplay = ({ comment, userSuggestions }) => {
            let text = comment || "";
            const parts = [];
            let lastIndex = 0;

            // Regex to find mentions (@anything) or links
            const regex = /(@[^\s@]+)|(https?:\/\/[^\s]+)/gi;

            let match;
            while ((match = regex.exec(text)) !== null) {
                const { index } = match;

                // Add text before the match
                if (index > lastIndex) {
                    parts.push(text.substring(lastIndex, index));
                }

                if (match[1]) {
                    // Potential mention
                    const mentionText = match[1].substring(1); // remove '@'

                    // Find full user name that includes this mentionText
                    const user = userSuggestions.find(u =>
                        u.name.toLowerCase().includes(mentionText.toLowerCase())
                    );

                    if (user) {
                        // Remove immediate duplicate of last word in mention
                        const mentionWords = user.name.split(" ");
                        const lastWord = mentionWords[mentionWords.length - 1];

                        const afterMention = text.slice(index + match[0].length);
                        const firstWordAfter = afterMention.match(/^\s+(\S+)/);
                        if (firstWordAfter && firstWordAfter[1] === lastWord) {
                            // Cut the repeated word
                            text = text.slice(0, index + match[0].length) + afterMention.slice(firstWordAfter[0].length);
                        }

                        parts.push(
                            <span key={index} style={{ fontWeight: "bold", color: "#0369a1" }}>
                                @{user.name}
                            </span>
                        );
                    } else {
                        // Not a valid mention, show normally
                        parts.push(match[1]);
                    }
                } else if (match[2]) {
                    // Link
                    parts.push(
                        <a
                            key={index}
                            href={match[2]}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#1d4ed8", textDecoration: "underline" }}
                        >
                            {match[2]}
                        </a>
                    );
                }

                lastIndex = index + match[0].length;
            }

            // Add remaining text
            if (lastIndex < text.length) {
                parts.push(text.substring(lastIndex));
            }

            return <div style={{ whiteSpace: "pre-wrap" }}>{parts}</div>;
        };


        const checkDueDate = (date) => {
            if (!startDate) {
                setDueDate(date); 
                return;
            }

            if (formatDate(date) < formatDate(startDate)) {
                toast.error("Cannot set due date before start date")
                setDueDate(dueDate);
            } else {
                setDueDate(date);
            }
            };

       const checkStartDate = (date) => {
            if (!dueDate) {
                setStartDate(date); 
                return;
            }

            {console.log("due Date:",dueDate)}
            if (formatDate(dueDate) < formatDate(date)) {
                toast.error("Cannot set start date after due date")
                setStartDate(startDate);
            } else {
                setStartDate(date);
            }
            };

            



    return (
      <div
        ref={scrollRef}
        onScroll={handleScroll}
        className="modal show d-block custom-modal-overlay"
        role="dialog"
        onClick={handleOverlayClick}
        aria-modal="true"
        aria-labelledby="taskDetailsTitle"            
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.07)', }}>
        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div className="modal-content p-4" style={{border:"none", borderRadius:"6px"}}>
            {/* Header */}
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <h6 className="fw-semibold" style={{fontSize:"16px", fontWeight:"600", lineHeight:"24px", color:"#000", marginBottom:"10px"}}>{bucketName}</h6>
                <div>
                  <h2 id="taskDetailsTitle" className=" mb-1 d-flex align-items-center" style={{fontSize:"24px", fontWeight:"400", lineHeight:"30px", color:"#000"}}>
                    {isEditingName ? (
                      <input
                        type="text"
                        className="form-control"
                        value={editedName}
                        ref={nameInputRef}
                        autoFocus
                        onChange={(e) => setEditedName(e.target.value)}
                        onBlur={() => setIsEditingName(false)}
                        onKeyDown={(e) => e.key === 'Enter' && setIsEditingName(false)}
                      />

                    ) : (
                        <div
                        onClick={() => setIsEditingName(true)}
                        style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem"
                        }}
                        >
                          {console.log("Edited Name",editedName)}
                        {editedName || <i className="text-muted">Double click to edit</i>}
                        <Pencil size={18} color="#6c757d" />
                      </div>
                    )}
                  </h2>
                </div>
              </div>
              <button type="button" style={{fontSize:"14px", fontWeight:"200", color:"#000"}} className="btn-close" aria-label="Close" onClick={()=>{
                removeDraft()
                onClose()
              }}></button>
            </div>
            {/* Assigned Users */}
            <div style={{marginTop:"0px", marginBottom:"10px"}}>
              <div className='assignNew'>
                <div style={{fontSize:"14px", fontWeight:"400", lineHeight:"24px",color:"#000"}} className="task-option" onClick={()=>setShowAssigneeInput(prev => !prev)}>
                <img src="./assigne.png" alt="assigne" style={{width:"16px"}} /> Assign users
                </div>
                <div className="assigned-user-input mb-2">
                    {task.assigned_users?.length > 0 ? (
                    <>
                    <div className="d-flex flex-wrap align-items-center gap-2">
                    {task.assigned_users.map((user) => (
                        <div key={user.id} className="d-flex align-items-center mb-2">
                        <img
                            src={`https://teams.tidyds.com${user.profile_pic}`}
                            alt={user.name}
                            className="rounded-circle"
                            width="20"
                            height="20"
                            objectFit="cover"
                        />
                        <span className="ms-2" style={{fontFamily:"roboto", fontSize:"16px"}}>{user.name}</span>
                        </div>
                    ))}
                    </div>
                    </>
                    ) : (
                        <p className="text-muted mb-0"></p>
                    )}
                    {showAssigneeInput && (
                        <div className="assigned-user-input">
                            {/* Input for searching users */}
                            <input
                            type="text"
                            placeholder="Type name or email"
                            value={taskEdits.assigneeInput}
                            onChange={handleAssigneeInput}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" && filteredSuggestions.length) {
                                addAssignee(filteredSuggestions[0]); // pass whole user object
                                e.preventDefault();
                                }
                            }}
                            onFocus={handleFocus}
                            style={{ width: "240px" }}
                            autoFocus
                            />

                            {/* Dropdown with two sections */}
                            {(showDropdown)&&(taskEdits.assignees.length > 0 || filteredSuggestions.length > 0) && (
                            <div className="autocomplete-dropdown">
                                {/* Assigned Users Section */}
                                {taskEdits.assignees.length > 0 && (
                                <div className="dropdown-section">
                                    <div className="dropdown-heading">Assigned Users</div>
                                    {taskEdits.assignees.map(user => (
                                    <div key={`assigned-${user.id}`} className="autocomplete-item assigned">
                                        <div className='profile-assign'>
                                            <img src={
                                                    user.profile_pic.startsWith("http")
                                                    ? user.profile_pic
                                                    : `https://teams.tidyds.com${user.profile_pic}`
                                            } alt={user.name} className="avatar rounded-circle" />
                                            <div className="user-info">
                                                <div className="name" >{user.name}</div>
                                                <div className="email">{user.email}</div>
                                            </div>
                                        </div>
                                        {/* Remove button */}
                                        <button
                                        type="button"
                                        className="remove-btn"
                                        onClick={() => {
                                            setRemovedAssignees(prev => [...prev, { task_id: task.id, user_id: user.id }]);
                                            removeAssignee(user.id);
                                        }}
                                        >
                                        ×
                                        </button>
                                    </div>
                                    ))}
                                </div>
                                )}

                                {/* Suggestions Section */}
                                {filteredSuggestions.length > 0 && (
                                <div className="dropdown-section">
                                    <div className="dropdown-heading">Suggestions</div>
                                    {filteredSuggestions.map(user => (
                                    <div
                                        key={user.id}
                                        className="autocomplete-item"
                                        onClick={() => addAssignee(user)}
                                    >
                                        <img src={user.profile_pic} alt={user.name} className="avatar rounded-circle" />
                                        <div className="user-info">
                                        <div className="name">{user.name}</div>
                                        <div className="email">{user.email}</div>
                                        </div>
                                    </div>
                                    ))}
                                </div>
                                )}
                            </div>
                            )}
                        </div>
                    )}
                </div>
              </div>
            </div>
            {/* Editable Fields */}
            <div className="mb-4 row g-3">
              <div className="col-md-6">
                <label className="form-label labels">Bucket</label>
                <select className="form-select form-selectt" value={selectedBucket} onChange={(e) => {
                  const newBucketId = e.target.value;
                  setSelectedBucket(newBucketId);
                  const bucket = buckets?.find((b) => b.id.toString() === newBucketId.toString());
                  setBucketName(bucket.name)
                }}>
                  {buckets.map(bucket => (
                    <option key={bucket.id} value={bucket.id}>
                      {bucket.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label labels">Progress</label>
                <select className="form-select form-selectt" value={status} onChange={(e) => setStatus(e.target.value)}>
                    {console.log("Status:",status)}
                  <option value="Not Started">Not Started</option>
                  <option value="In Progress" >In Progress</option>
                    <option value="On Hold">On Hold</option>
                  <option value="Completed" >Completed</option>
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label labels">Priority</label>
                <select className="form-select form-selectt" value={priority} onChange={(e) => setPriority(e.target.value)}>
                    <option value="low">Low</option>
                    <option value="medium">Medium</option>
                    <option value="high">High</option>
                </select>
              </div>
              <div className="col-md-3 ">
                <label className="form-label labels">Start Date</label>
                <DatePicker
                    selected={startDate}
                    onChange={(date) => checkStartDate(date)}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Select a date"
                    className="border p-2 rounded  form-selectt"
                />
                
              </div>

              <div className="col-md-3">
                <label className="form-label labels">Due Date</label>
                <DatePicker
                    selected={dueDate}
                    onChange={(date)=>checkDueDate(date)}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Select a date"
                    className="border p-2 rounded  form-selectt"
                />
              </div>

              <div className="col-12">
                <div className='d-flex justify-content-between'>
                  <label className="form-label labels">Notes</label>
                    <div className="d-flex align-items-center ">
                        <input type="checkbox"  id="showOnCard" checked={showNotes} onChange={(e) =>{
                            setShowChecklist(false)
                            setShowImage(null)
                            setShowNotes(e.target.checked)
                        }} style={{width:"40px",fontWeight:'bold', accentColor:"#45048a"}} />
                        <label htmlFor="showOnCard" className="mb-0">Show on card</label>
                    </div>
                    {console.log("Notes Checks:",showNotes)}
                </div>
                <textarea 
                ref={notesRef}
                name="notes"
                className="form-control  form-selectt notes" 
                rows="3" 
                value={notes} 
                onChange={(e) => setNotes(e.target.value)}
                onFocus={() => handleFocusField("notes",notesRef)}
                onBlur={handleBlur}
                onSelect={() => handleSelect(notesRef)} // track live cursor
                ></textarea>
              </div>
            </div>
            {/* Checklist */}
            <div className="mb-4">
              <div className='d-flex justify-content-between'>
                  <label className="form-label labels">Checklist</label>
                    <div className="d-flex align-items-center">
                        <input type="checkbox" id="showOnCard" checked={showChecklist} onChange={(e) => {
                            setShowNotes(false)
                            setShowImage(null)
                            setShowChecklist(e.target.checked)
                        }} style={{width:"40px",fontWeight:'bold', accentColor:"#45048a"}} />
                        <label htmlFor="showOnCard" className="mb-0">Show on card</label>
                    </div>
                    {console.log("Checklist check:",showChecklist)}
                </div>
              <small className="text-muted">{getChecklistProgress()}% complete</small>
                <div class="progress" style={{marginBottom:"15px"}}>
                    <div class="progress-bar" role="progressbar" style={{width:`${getChecklistProgress()}%`}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" >{getChecklistProgress()}%</div>
                </div>
              {checklist.map((item, index) => (
                 <div
                key={index}
                className="d-flex justify-content-between align-items-center mb-2"
                >
                <div className='d-flex'>
                    <input
                    type="checkbox"
                    className="form-check-input check-input me-2 w-c-i"
                    checked={item.done}
                    onChange={() => toggleChecklistItem(index)}
                    />

                    {editIndex === index ? (
                    <input
                        name="editchecklist"
                        type="text"
                        className="form-control form-control-sm d-inline h-2"
                        value={editedText}
                        style={{width:"700px"}}
                        ref={setRefs(inputRef,oldChecklistRef)}
                        onChange={(e) => setEditedText(e.target.value)}
                        onBlur={
                            ()=>{
                                saveChecklistItem(index)
                                handleBlur()
                                handleBlurField("checklist")
                            }}
                        onFocus={() => handleFocusField("editchecklist",oldChecklistRef)}
                        onSelect={() => handleSelect(oldChecklistRef)} // track live cursor
                        onKeyDown={(e) => e.key === "Enter" && saveChecklistItem(index)}
                    />
                    ) : (
                    <span onClick={()=>{
                        if (index !== undefined && index !== null) {
                            setLastEditindex(index)
                        }
                        editChecklist(index)
                    {console.log("Click edit index : ",index)}
                        }} style={{cursor:"pointer", whiteSpace:"normal", wordBreak:"break-word",maxWidth:"100%"}} className={item.done ? "text-decoration-line-through" : ""}>
                        {item.text}
                    </span>
                    )}
                    {console.log("Checklist edit index : ",editIndex)}
                </div>

                <div className='d-flex gap-2 ' style={{alignSelf:"start"}}>

                    <img className='icons'
                        src={delete_icon}
                        title='delete'
                        onClick={() => removeChecklistItem(index)}
                        />
                </div>
                </div>
              ))}
              {newItemVisible ? (
                <input
                    ref={checklistRef}
                    name="checklist"
                    type="text"
                    className="form-control mt-2 ggff"
                    value={newItem}
                    autoFocus
                    onChange={(e) => setNewItem(e.target.value)}
                    onBlur={() => {
                        handleBlur()
                        handleAddChecklistItem()
                    }}
                    onFocus={() => handleFocusField("checklist",checklistRef)}
                    onSelect={() => handleSelect(checklistRef)}
                    onKeyDown={(e) => e.key === 'Enter' && handleAddChecklistItem()}
                />
              ) : (
                <div className=" btn mt-2" style={{ cursor: 'pointer', background:"#9747ff", borderRadius:"8px", color:"#fff" }} onClick={() => setNewItemVisible(true)}>
                  Add an item
                </div>
              )}
            </div>
            {/* Attachments */}
            <div className="mb-4">
                <h6 className="labels mb-2">Attachments</h6>

                {/* Image previews with actions */}
                <div className="mb-2 d-flex flex-column flex-wrap gap-3">
                    {attachments.map((file, index) => (
                    <div className='d-flex justify-content-between'>
                    <div
                        className='d-flex  align-items-center mb-2 p-2 border rounded bg-light'
                        key={file.id || index}
                        style={{ position: "relative" }}
                    >
                        <img
                        src={`https://teams.tidyds.com${file.url}`}
                        alt={file.name || "attachment"}
                        style={{
                            width: "40px",
                            height: "40px",
                            objectFit: "cover",
                            borderRadius: "4px",
                            cursor: "pointer",
                        }}
                        onClick={() =>
                            window.open(`https://teams.tidyds.com${file.url}`, "_blank")
                        }
                        />
                        <div className="ms-2 flex-grow-1">
                        <div
                        className="fw-semibold text-truncate"
                        style={{ maxWidth: "200px" }}
                        >
                            {file.name}
                            </div>
                                <a
                                href={`https://teams.tidyds.com${file.url}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="small text-muted d-block text-truncate"
                                style={{ maxWidth: "200px" }}
                                >
                                {`https://teams.tidyds.com${file.url}`}
                            </a>
                        </div>

                        <img
                        className='icons'
                        src={delete_icon}
                        onClick={() => removeAttachment(file.id || index)}
                        />
                       
                    </div>
                    <div className="d-flex align-items-center">
                        <input
                            type="checkbox"
                            id={`showOnCard-${index}`}
                            checked={showImage === `https://teams.tidyds.com${file.url}`} // ✅ check only if this URL is selected
                            onChange={() => {
                            setShowChecklist(false);
                            setShowNotes(false);
                            setShowImage(
                                showImage === `https://teams.tidyds.com${file.url}`
                                ? null // uncheck if already selected
                                : `https://teams.tidyds.com${file.url}` // select this URL
                            );
                            }}
                            style={{ width: "40px", fontWeight: "bold",accentColor:"#45048a" }}
                        />
                        <label htmlFor={`showOnCard-${index}`} className="mb-0">
                            Show on card
                        </label>
                    </div>

                    {console.log("Image Checks:",showImage)}
                    </div>
                    ))}
                </div>

                <input
                    type="file"
                    id='fileInput'
                    placeholder='Add attachments'
                    className="custom-file-input"
                    multiple
                    onChange={handleFile}
                    aria-label="Upload attachments"
                />
            </div>


            {/* Comments */}
            <div className="mb-4">
              <h6 className="labels mb-2">Comments</h6>
              <MentionsInput 
                inputRef={commentsRef}
                name="comments"
                className='mentions  form-selectt'
                value={commentInput}
                onChange={(e, newValue) => setCommentInput(formatComment(newValue))}
                onBlur={() => {
                        handleBlur()
                    }}
                onFocus={() => handleFocusField("comments",commentsRef)}
                onSelect={() => handleSelect(commentsRef)}
                >
               <Mention
                className="mentions__mention"
                trigger="@"
                data={userSuggestions.map((u) => ({ id: u.id, display: u.name }))}
                markup="@__id__|__display__"  // save both
                displayTransform={(id, display) => `@${display}`}
                />
                </MentionsInput>
              <button style={{background:"#9747ff", color:"#fff"}} className="btn mb-2 mt-3" onClick={handleAddComment}>Send</button>
              {comments.map((comment, index) => (
                <div key={index} className="d-flex justify-content-between align-items-center border p-2 rounded mb-2">
                <div>
                    <div className="fw-semibold">{comment.user}</div>
                    {commentEditIndex === index ? (
                        <MentionsInput
                            name="editComment"
                            inputRef={editCommentRef}
                            onFocus={() => handleFocusField("editComment",editCommentRef)}
                            onSelect={() => handleSelect(editCommentRef)} // track live cursor
                            className='mentions'
                            value={commentEditedText}
                            onChange={(e, newValue) => setCommentEditedText(formatComment(newValue))}
                            >
                        <Mention
                        className="mentions__mention"
                            trigger="@"
                            data={userSuggestions.map((u) => ({ id: u.id, display: u.name }))}
                            markup="@__id__|__display__"  // save both
                            displayTransform={(id, display) => `@${display}`}
                            />
                        </MentionsInput>
                    ) : (
                        <CommentDisplay comment={comment.text} userSuggestions={userSuggestions} />
                    )}

                    <small className="text-muted d-block mb-2">{comment.time}</small>
                    </div>
                    <div className='d-flex gap-2 '>
                        {commentEditIndex === index ? (
                        <img className='icons'
                        src={save_icon}
                        title='save'
                        onClick={() =>{
                            handleBlur()
                            saveComment(index)
                            handleBlurField("comment")
                        }}
                        />
                       
                    ) : (
                        <img className='icons'
                        src={edit_icon}
                        title='edit'
                        onClick={() =>{ 
                            editComment(index)
                            if (index !== undefined && index !== null) {
                                console.log("Comment:", index);
                                setLastCommentEditindex(index);
                            }
                        }
                        }
                        />
                    )}

                    <img className='icons'
                        src={delete_icon}
                        title='delete'
                        onClick={() => removeComment(index)}
                        />
                    </div>
                </div>
            ))}
            </div>
            <div className="card mt-3 shadow-sm">
              <div className="card-header bg-light">
                <h6 className="mb-0">Activity Logs</h6>
              </div>
              {taskLogs && taskLogs.length > 0  ? 
              (<div className="card-body p-2" style={{ maxHeight: "250px", overflowY: "auto" }}> 
                <ul className="list-group list-group-flush">
                  {logs 
                    .filter(log => log.task_id === task.id)
                    .map(log => (
                      <li key={log.id} className="list-group-item d-flex justify-content-between align-items-start">
                        <div className="ms-2 me-auto">
                          <div className="fw-bold" >{users[log.user_id]}</div>
                          {Array.isArray(log.description) ? (
                                <ul className="mb-0 ps-3">
                                    {log.description.map((desc, i) => (
                                        <li key={i}>{desc}</li>
                                    ))}
                                </ul>
                                ) : (
                                    <ul className="mb-0 ps-3">
                                    {(typeof log.description === "string" ? log.description.split(",") : [])
                                        .filter(Boolean)
                                        .map((desc, i) => (
                                        <li key={i}>{desc.trim()}</li>
                                        ))}
                                    </ul>
                                )}
                                <div className="text-secondary" style={{fontSize:"14px"}}>{new Date(log.created_at).toLocaleString()}</div>
                        </div>
                      </li>
                    ))}
                </ul>
              </div>)
              :
              (<div className="card-body p-2" style={{ maxHeight: "250px", overflowY: "auto" }}>No activity yet</div>) }
            </div>
            

            {showSuccess && (
              <div className="toast-popup">
                <div className="toast-message">
                  Changes saved successfully!
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  export default TaskDetailsModal;
